import { services } from "@/mocks/home";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

function ServiceCard({ service, index }: { service: typeof services[0]; index: number }) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`group relative bg-background-200 border border border-primary-500/40 rounded-xl overflow-hidden hover:border-primary-500 transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="relative h-48 md:h-58 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-200 via-background-200/30 to-transparent"></div>
        <div className="absolute top-4 left-4 w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center">
          <i className={`${service.icon} text-foreground-50 text-3xl`}></i>
        </div>
      </div>

      <div className="p-5 md:p-4">
        <h3 className="text-foreground-50 text-xl font-bold font-heading mb-3">
          {service.title}
        </h3>
        <ul className="space-y-2">
          {service.items.map((item, idx) => (
            <li
              key={idx}
              className="flex items-center gap-2 text-foreground-400 text-sm"
            >
              <i className="ri-check-line text-primary-400 text-xs"></i>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Services() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();

  return (
    <section id="services" className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div
            ref={titleRef}
            className={`text-center mb-12 md:mb-16 transition-all duration-700 ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
          >

            <h2 className="flex items-center justify-center gap-4 md:gap-8 text-2xl md:text-4xl lg:text-5xl font-black font-heading text-foreground-50">
              <span className="w-16 md:w-52 h-px bg-gradient-to-l from-primary-500 to-transparent" />
              対応サービス
              <span className="w-16 md:w-52 h-px bg-gradient-to-r from-primary-500 to-transparent" />
            </h2>
            <p className="text-primary-400 text-sm">OUR SERVICES</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {services.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}